import { render } from "./App.vue?vue&type=template&id=2076ec91"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/carloslazcanoyoung/PROJECT/MUSS/COMPANY/SOFOFA/IEE/iee-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__